import { render, staticRenderFns } from "./OrderFoodSpecEdit.vue?vue&type=template&id=19dc3302&scoped=true"
import script from "./OrderFoodSpecEdit.vue?vue&type=script&lang=js"
export * from "./OrderFoodSpecEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodSpecEdit.vue?vue&type=style&index=0&id=19dc3302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc3302",
  null
  
)

export default component.exports